import React from 'react';
import { SmartTagsWysiwyg, WysiwygProps } from 'ui-builder';
import { useSmartTagsContext } from '../../smarttags/SmartTagsContext';

export default function SmsSmartTagsWysiwyg(props: WysiwygProps) {
  const smartTagsContext = useSmartTagsContext();

  return (
    <SmartTagsWysiwyg
      {...props}
      availableTags={smartTagsContext.availableTags}
      hideControls
    />
  );
}
